import { apolloProvider } from '@/apollo-provider.js'
import { fetchDataWithCache } from '@/helpers/cacheHelper'
import {
  QUERY_GET_DRE_REVENUE_INCREMENT_METRICS,
  QUERY_GET_DRE_OFFERS_COUPONS_METRICS,
  QUERY_GET_DRE_PRODUCTS_METRICS,
  QUERY_GET_DRE_CLIENTS_DISTRIBUTION_BEFORE,
  QUERY_GET_DRE_CHANNELS_DISTRIBUTION,
  QUERY_GET_DRE_OFFERS_SCHEDULES_RESULT,
} from '../graphql'

export default {
  setDreAnalysedPeriod({ commit }, payload) {
    commit('SET_DRE_ANALYSED_PERIOD', payload)
  },
  async getDreRevenueIncrementMetrics({ rootState, commit }, params) {
    try {
      const { lastUpdate } = rootState

      const fetchFunction = async () => {
        const response = await apolloProvider.defaultClient
          .query({
            query: QUERY_GET_DRE_REVENUE_INCREMENT_METRICS,
            variables: {
              input: params.input,
            },
            fetchPolicy: 'no-cache',
          })
          .then(({ data: dreRevenueIncrementMetrics }) => {
            return dreRevenueIncrementMetrics
          })
        return response.dreRevenueIncrementMetrics
      }

      const dreRevenueIncrementMetrics = params.useCache
        ? await fetchDataWithCache('dreRevenueIncrementMetrics', fetchFunction, lastUpdate?.last_updated, lastUpdate?.processing_uuid)
        : await fetchFunction()

      commit('SET_DRE_REVENUE_INCREMENT_METRICS', dreRevenueIncrementMetrics)
    } catch (error) {
      console.error(error)
      commit('SET_DRE_REVENUE_INCREMENT_METRICS', {})
    }
  },

  async getDreOffersCouponsMetrics({ commit }, variables) {
    try {
      const { dreOffersCouponsMetrics } = await apolloProvider.defaultClient
        .query({
          query: QUERY_GET_DRE_OFFERS_COUPONS_METRICS,
          variables,
          fetchPolicy: 'no-cache',
        })
        .then(({ data: dreOffersCouponsMetrics }) => {
          return dreOffersCouponsMetrics
        })
      commit('SET_DRE_OFFERS_COUPONS_METRICS', dreOffersCouponsMetrics)
    } catch (error) {
      console.error(error)
      commit('SET_DRE_OFFERS_COUPONS_METRICS', {})
    }
  },

  async getDreProductsMetrics({ commit }, variables) {
    try {
      const { dreProductsMetrics } = await apolloProvider.defaultClient
        .query({
          query: QUERY_GET_DRE_PRODUCTS_METRICS,
          variables,
          fetchPolicy: 'no-cache',
        })
        .then(({ data: dreProductsMetrics }) => {
          return dreProductsMetrics
        })
      commit('SET_DRE_PRODUCTS_METRICS', dreProductsMetrics)
    } catch (error) {
      console.error(error)
      commit('SET_DRE_PRODUCTS_METRICS', {})
    }
  },

  async getDreClientsDistributionBefore({ rootState, commit }, params) {
    try {
      const { lastUpdate } = rootState

      const fetchFunction = async () => {
        const response = await apolloProvider.defaultClient
          .query({
            query: QUERY_GET_DRE_CLIENTS_DISTRIBUTION_BEFORE,
            variables: {
              input: params.input,
            },
            fetchPolicy: 'no-cache',
          })
          .then(({ data: dreClientsDistributionBefore }) => {
            return dreClientsDistributionBefore
          })
        return response.dreClientsDistributionBefore
      }

      const dreClientsDistributionBefore = params.useCache
        ? await fetchDataWithCache('dreClientsDistributionBefore', fetchFunction, lastUpdate?.last_updated, lastUpdate?.processing_uuid)
        : await fetchFunction()

      commit('SET_DRE_CLIENTS_DISTRIBUTION_BEFORE', dreClientsDistributionBefore)
    } catch (error) {
      console.error(error)
      commit('SET_DRE_CLIENTS_DISTRIBUTION_BEFORE', {})
    }
  },

  async getDreChannelsDistribution({ commit }, variables) {
    try {
      const { dreChannelsDistribution } = await apolloProvider.defaultClient
        .query({
          query: QUERY_GET_DRE_CHANNELS_DISTRIBUTION,
          variables,
          fetchPolicy: 'no-cache',
        })
        .then(({ data: dreChannelsDistribution }) => {
          return dreChannelsDistribution
        })
      commit('SET_DRE_CHANNELS_DISTRIBUTION', dreChannelsDistribution)
    } catch (error) {
      console.error(error)
      commit('SET_DRE_CHANNELS_DISTRIBUTION', {})
    }
  },

  async getDreOffersSchedulesResult({ rootState, commit }, params) {
    try {
      const { lastUpdate } = rootState

      const fetchFunction = async () => {
        const response = await apolloProvider.defaultClient
          .query({
            query: QUERY_GET_DRE_OFFERS_SCHEDULES_RESULT,
            variables: {
              input: params.input,
            },
            fetchPolicy: 'no-cache',
          })
          .then(({ data: dreOffersSchedulesResult }) => {
            return dreOffersSchedulesResult
          })
        const { hasOffersSchedulesResult } = response.dreOffersSchedulesResult
        return hasOffersSchedulesResult
      }

      const hasOffersSchedulesResult = params.useCache
        ? await fetchDataWithCache('hasOffersSchedulesResult', fetchFunction, lastUpdate?.last_updated, lastUpdate?.processing_uuid)
        : await fetchFunction()

      commit('SET_HAS_DRE_OFFERS_SCHEDULES_RESULTS', hasOffersSchedulesResult)
    } catch (error) {
      console.error(error)
      commit('SET_HAS_DRE_OFFERS_SCHEDULES_RESULTS', false)
    }
  },
}
